<template>
  <div>
    <svg
         :width="iconSize"
         :height="iconSize"
         viewBox="0 0 25 25"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M9.27558 7V12.2124H3V7H9.27558ZM6.10977 7.60217C5.83982 7.60217 5.59985 7.64804 5.3899 7.7394C5.17974 7.83117 5.01664 7.96279 4.90062 8.13468C4.78438 8.30657 4.72628 8.50837 4.72628 8.74027C4.72628 8.98691 4.78336 9.18393 4.89771 9.33153C5.01207 9.47913 5.14891 9.58937 5.30826 9.66224C5.46761 9.73511 5.67466 9.80903 5.92981 9.88356C6.11728 9.93588 6.26435 9.98363 6.37119 10.0266C6.47807 10.0696 6.56722 10.1285 6.63845 10.2031C6.70948 10.278 6.74531 10.3733 6.74531 10.4889C6.74531 10.6311 6.6926 10.7459 6.58783 10.8338C6.48283 10.9216 6.33828 10.9656 6.15477 10.9656C5.97481 10.9656 5.83316 10.9189 5.73006 10.8253C5.62696 10.732 5.56989 10.6048 5.55863 10.4441H4.71503C4.71878 10.6833 4.78438 10.8907 4.91187 11.0663C5.03915 11.2421 5.21266 11.3764 5.43199 11.4699C5.65133 11.5633 5.89774 11.61 6.17165 11.61C6.46034 11.61 6.70946 11.5569 6.91964 11.4504C7.12959 11.3439 7.28874 11.2008 7.39767 11.0215C7.5062 10.8423 7.56077 10.648 7.56077 10.4385C7.56077 10.1956 7.50246 9.99961 7.38644 9.85013C7.27021 9.70066 7.13128 9.58856 6.97026 9.51361C6.80904 9.43908 6.60073 9.36413 6.34599 9.2894C6.15832 9.23354 6.01313 9.18393 5.91003 9.14074C5.80693 9.09799 5.72068 9.04193 5.65133 8.9728C5.58197 8.90367 5.54738 8.81687 5.54738 8.71204C5.54738 8.56277 5.5932 8.44879 5.68507 8.37032C5.77694 8.29184 5.89962 8.2526 6.05355 8.2526C6.22976 8.2526 6.37119 8.2964 6.47805 8.38422C6.5849 8.47205 6.64197 8.58313 6.64968 8.71765H7.51578C7.48931 8.36637 7.34975 8.09275 7.09667 7.89656C6.8436 7.70037 6.51469 7.60217 6.10977 7.60217ZM16.1363 7.00554V12.2179H9.86068V7.00554H16.1363ZM12.107 7.65274H11.3197V11.5709H12.107V8.88593L13.8898 11.5709H14.6772V7.65274H13.8898V10.3433L12.107 7.65274ZM22.9967 7.00554V12.2179H16.7212V7.00554H22.9967ZM18.6134 7.65552H17.7192V11.5681H18.5065V9.02324L19.5638 11.5681H20.1599L21.2116 9.02324V11.5681H21.999V7.65552H21.1104L19.8619 10.5647L18.6134 7.65552ZM16.1325 12.7879V18H9.857V12.7879H16.1325ZM11.749 13.4377H10.8548V17.3502H11.6421V14.8054L12.6994 17.3502H13.2956L14.3473 14.8054V17.3502H15.1346V13.4377H14.2461L12.9975 16.3469L11.749 13.4377ZM23 12.7851V17.9975H16.7245V12.7851H23ZM20.2561 13.4349H19.4687V17.3474H20.2561V13.4349Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmi',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>